// extracted by mini-css-extract-plugin
export default {"label":"SelectDefaultLanguageModal_label__9nDQH","list":"SelectDefaultLanguageModal_list__pBlcX"};